import { ROUTE_HOMEPAGE } from '@1bill-app/constants';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Facebook } from '@awesome-cordova-plugins/facebook/ngx';
import { NavController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
/**
 * Page for uploading bills.
 */
@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.page.html',
  styleUrls: ['./upload-file.page.scss'],
})
export class UploadFilePage implements OnInit {
  routes = { homepage: ROUTE_HOMEPAGE, firstBillUpload: '/first-bill/upload' };
  isFirstBillUpload: boolean;
  uploading: boolean;
  uploaded: boolean;
  failed: boolean;
  _failedTest: boolean;

  constructor(
    private navCtrl: NavController,
    private logger: NGXLogger,
    private route: ActivatedRoute,
    private router: Router,
    private fb: Facebook,
  ) {
    this.uploading = true;
    setTimeout(
      (() => {
        this.uploading = false;
        if (this._failedTest) {
          this.failed = true;
        } else {
          this.uploaded = true;
        }
      }).bind(this),
      3000,
    );
  }

  ngOnInit() {
    this.isFirstBillUpload = this.route.snapshot.queryParamMap.has('fb_upload');
    // track Facebook SDK event for native apps - Start Trial
    this.fb.logEvent('Start Trial');
    this.logger.debug('UploadFilePage | isFirstBillUpload: ', this.isFirstBillUpload);
    this._failedTest = this.route.snapshot.queryParamMap.has('failed_test');
    if (this._failedTest) {
      this.logger.debug('UploadFilePage | Testing upload failed: ', this._failedTest);
    }
  }

  onGoHomeClick() {
    this.navCtrl.navigateRoot([ROUTE_HOMEPAGE]);
  }
  async goToFirstBillSelect() {
    this.router.navigate(['first-bill/select']);
  }
}
